import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Divider from 'src/components/ui/Divider/Divider';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import { useReturnCreate } from 'src/services/returns';
import { ReturnsCreateShell } from './ReturnsCreateTracking';
import { ActionBar, ReturnsConfiguratorForm, Section } from './ReturnsConfiguratorForm';
import { useReturnsFormContext } from './ReturnsFormContext';

const ReturnsCreateSummary: React.FC<{}> = () => {
  const { t } = useTranslation();

  const { formState } = useReturnsFormContext();
  const navigate = useNavigate();
  const createMutation = useReturnCreate();

  const createReturn = async () => {
    try {
      const response = await createMutation.mutateAsync({
        params: {
          path: {
            sale_order_id: formState.tracking.orders[0].id,
          },
        },
        body: {
          return_quantities: formState.products.data,
        },
      });
      if (response) {
        toast.success(t('returns.return_created'));
        navigate('/returns/create/done');
      }
    } catch (error) {
      toast.error(t('errors.create_return_failed'));
    }
  };

  return (
    <ReturnsCreateShell step={3} title={t('navbar.returns')} headline={t('navbar.create_return')}>
      <div className="grid gap-y-20">
        <Section className="flex flex-col gap-y-32">
          <ReturnsConfiguratorForm step={3} />
          <Divider className="" />
          <ActionBar>
            <Button
              title={t('general.cancel')}
              tone={ButtonToneProps.SECONDARY}
              onClick={() => {
                navigate('/returns');
              }}
            />
            <Button title={t('general.confirm')} onClick={createReturn} tone={ButtonToneProps.PRIMARY_BLUE} />
          </ActionBar>
        </Section>
      </div>
    </ReturnsCreateShell>
  );
};

export default ReturnsCreateSummary;
